import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const pricingPlans = [{
  name: "Standard Pakke",
  price: "14 990",
  period: "kr/mnd",
  description: "Kom i gang med AI-automatisering. For deg som jobber alene eller i lite team.",
  features: ["Xora Automation*", "AI-genererte boligbeskrivelser", "Integrasjon med Finn.no", "E-post support", "Månedlig rapport"],
  buttonText: "Kom i gang",
  isPopular: false,
  link: "/Order"
}, {
  name: "Proff Pakke",
  price: "29 990",
  period: "kr/mnd",
  description: "Full AI-kraft for kontoret som vil dominere lokalmiljøet sitt.",
  features: ["Alt i Standard-pakken", "Opptil 5 aktive annonser", "Automatisert sosiale medier", "Prioritert 24/7 support", "Ubegrenset antall annonser", "API-tilgang for integrasjoner"],
  buttonText: "Kom i gang",
  isPopular: true,
  link: "/Order"
}, {
  name: "Ultimat Pakke",
  price: "59 990",
  period: "kr/mnd",
  description: "Skreddersydde AI-løsninger for de som vil eie sin egen teknologi.",
  features: ["Alt i Proff-pakken", "Egen AI-modell for ditt firma", "Integrasjon med Outlook/Google", "Dedikert Account Manager", "Strategisk rådgivning", "Hvitmerket løsning", "Avansert dataanalyse"],
  buttonText: "Kom i gang",
  isPopular: false,
  link: "/Order"
}];
export default function FlexibleHiringPackages() {
  return <section data-section-id="223873" id="våre-pakker" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/20 via-background to-background pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold mb-4 tracking-tighter text-foreground">
            Våre Pakker
          </h2>
          <p className="text-lg text-muted-foreground font-default">Velg den løsningen som passer ditt meglerhus best. Xora automatiserer de tidkrevende oppgavene slik at du kan selge mer.<br /></p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-start max-w-5xl mx-auto">
          {pricingPlans.map((plan, i) => <div data-index={i} key={plan.name} className="relative h-full">
              <Card className={`h-full flex flex-col transition-all duration-500 hover:shadow-2xl ${plan.isPopular ? "bg-card/60 backdrop-blur-md border-2 border-primary shadow-lg shadow-primary/20 scale-105 z-10" : plan.name === "Ultimat" ? "bg-slate-900/80 border border-white/10 shadow-xl" : "bg-card/40 backdrop-blur-sm border border-border hover:border-primary/50"}`}>
                {plan.isPopular && <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                    <Badge className="bg-gradient-to-r from-primary to-chart-2 text-primary-foreground px-4 py-1 text-xs font-bold uppercase tracking-widest rounded-lg">
                      Mest Populær
                    </Badge>
                  </div>}

                <CardHeader className="text-center pb-8 pt-8">
                  <CardTitle className={`text-xl font-default font-bold mb-2 ${plan.name === "Ultimat" ? "text-chart-2" : "text-muted-foreground"}`}>
                    {plan.name}
                  </CardTitle>
                  <div className="flex items-baseline justify-center gap-1">
                    <span className="text-5xl font-mono font-bold tracking-tighter text-foreground">
                      {plan.price}
                    </span>
                    {plan.period && <span className="text-muted-foreground font-mono text-sm">
                        {plan.period}
                      </span>}
                  </div>
                  <CardDescription className="mt-4 text-sm font-default h-10 text-muted-foreground">
                    {plan.description}
                  </CardDescription>
                </CardHeader>

                <CardContent className="flex-grow">
                  <ul className="space-y-4">
                    {plan.features.map((feature, index) => {
                  if (index === 0) {
                    return <Card key={index} className="bg-primary/10 border-none p-4 flex flex-row items-center gap-3 shadow-sm">
                            <Check className="size-5 text-primary shrink-0" />
                            <span className="text-sm font-default font-medium text-foreground">
                              {feature}
                            </span>
                          </Card>;
                  }
                  return <li key={index} className="flex items-start gap-3">
                          <Check className="size-5 text-primary shrink-0 mt-0.5" />
                          <span className="text-sm font-default text-foreground/90">
                            {feature}
                          </span>
                        </li>;
                })}
                  </ul>
                </CardContent>

                <CardFooter className="pt-8 pb-8">
                  <Button asChild className={`w-full font-default font-bold transition-all duration-300 rounded-md ${plan.isPopular ? "bg-gradient-to-r from-primary to-chart-2 text-primary-foreground hover:opacity-90 shadow-lg shadow-primary/20" : plan.name === "Ultimat" ? "bg-foreground text-background hover:bg-foreground/90" : "bg-transparent border border-border text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary"}`} size="lg">
                    <Link to="https://xora.no/bestill/">Kom i gang</Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
        <p className="text-center mt-8 text-muted-foreground font-default">&nbsp; Alle priser er eksludert MVA og gjelder per kontor.<div><br /></div><div contenteditable="false" style={{}}>Xora dekker API bruk opp til 1000kr i mnd.</div><div><br /></div><div>Xora Automation står forklart nederst på denne siden*</div></p>
      </div>
    </section>;
}